import MuiButton from '@mui/material/Button';
import withStyles from '@mui/styles/withStyles';

const Button = withStyles({
  root: {
    fontFamily: 'Rubik, sans-serif',
    fontSize: '12px',
    border: '1px solid #208cd7',
    borderRadius: '4px',
    width: '131px',
    padding: 0,
    textTransform: 'none',
    fontWeight: 'normal',
    '&:hover': {
      background: '#inherit',
    },
  },
  // select: {
  //   textTransform: 'capitalize',
  // },
})(MuiButton);

export default Button;
